import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import {
  allowedDocExtensions,
  allowedDocMimeTypes,
} from "../common/dragUpload";
import { useState } from "react";

export const allowedImageExtensions = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "webp",
  "tiff",
  "tif",
  "svg",
];

export const allowedImageMimeTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/tiff",
  "image/svg+xml",
];

export const setCookie = (name, value) => {
  document.cookie = `${name}=${value}; path=/;`;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return false;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
};

const extraMenuItems = [
  {
    key: "dashboard",
    // icon: <DashboardOutlined />,
    label: "Dashboard",
    children: [
      {
        key: "analytics",
        // icon: <BarChartOutlined />,
        label: "Analytics",
        children: [
          { key: "sales-analytics", label: "Sales Analytics" },
          { key: "user-analytics", label: "User Analytics" },
          { key: "traffic-analytics", label: "Traffic Analytics" },
        ],
      },
      {
        key: "reports",
        // icon: <FileOutlined />,
        label: "Reports",
        children: [
          { key: "monthly-reports", label: "Monthly Reports" },
          { key: "quarterly-reports", label: "Quarterly Reports" },
          { key: "annual-reports", label: "Annual Reports" },
        ],
      },
    ],
  },
  {
    key: "vendor_master",
    // icon: <UserOutlined />,
    label: "Vendor Master",
    children: [
      {
        key: "new_vendor_registration",
        // icon: <TeamOutlined />,
        label: "New vendor Registration",
        // children: [
        //   { key: "all-users", label: "All Users" },
        //   { key: "active-users", label: "Active Users" },
        //   { key: "inactive-users", label: "Inactive Users" },
        // ],
      },
      {
        key: "user-roles",
        // icon: <SecurityScanOutlined />,
        label: "Roles & Permissions",
        children: [
          { key: "admin-roles", label: "Admin Roles" },
          { key: "user-roles", label: "User Roles" },
          { key: "custom-roles", label: "Custom Roles" },
        ],
      },
    ],
  },
  {
    key: "products",
    // icon: <ShoppingOutlined />,
    label: "Products",
    children: [
      {
        key: "inventory",
        // icon: <AppstoreOutlined />,
        label: "Inventory",
        children: [
          { key: "in-stock", label: "In Stock" },
          { key: "out-of-stock", label: "Out of Stock" },
          { key: "low-stock", label: "Low Stock" },
        ],
      },
      {
        key: "categories",
        // icon: <DatabaseOutlined />,
        label: "Categories",
        children: [
          { key: "electronics", label: "Electronics" },
          { key: "clothing", label: "Clothing" },
          { key: "home-garden", label: "Home & Garden" },
        ],
      },
    ],
  },
  {
    key: "settings",
    // icon: <SettingOutlined />,
    label: "Settings",
    children: [
      {
        key: "general-settings",
        // icon: <ToolOutlined />,
        label: "General",
        children: [
          { key: "profile-settings", label: "Profile" },
          { key: "account-settings", label: "Account" },
          { key: "privacy-settings", label: "Privacy" },
        ],
      },
      {
        key: "system-settings",
        // icon: <CloudOutlined />,
        label: "System",
        children: [
          { key: "notifications", label: "Notifications" },
          { key: "integrations", label: "Integrations" },
          { key: "api-keys", label: "API Keys" },
        ],
      },
    ],
  },
];
export const HeaderDivider = ({ title = "General Info", isShort = false }) => {
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    margin: isShort ? "0 0 20px 0" : "24px 0 20px 0",
  };

  const titleStyle = {
    color: "#475569",
    fontWeight: "600",
    fontSize: "11px",
    letterSpacing: "0.12em",
    whiteSpace: "nowrap",
    textTransform: "uppercase",
    padding: "0",
    backgroundColor: "transparent",
  };

  const dividerStyle = {
    flex: 1,
    height: "1px",
    background:
      "linear-gradient(to right, transparent, #cbd5e1 20%, #cbd5e1 80%, transparent)",
  };

  return (
    <div style={containerStyle}>
      <div style={dividerStyle}></div>
      <span style={titleStyle}>{title}</span>
      <div style={dividerStyle}></div>
    </div>
  );
};
export const CustomLabel = ({ children, isImportnt }) => {
  return (
    <label
      style={{
        fontSize: "12px",
        fontWeight: "500",
        marginBottom: "4px",
        display: "block",
      }}
    >
      {children}
      {isImportnt && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
    </label>
  );
};

export const RightDivider = ({ title = "General Info" }) => {
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    paddingLeft: "24px",
    paddingRight: "24px",
  };

  const titleStyle = {
    color: "black",
    fontWeight: "600",
    fontSize: "18px",
    whiteSpace: "nowrap",
    flexShrink: 0,
  };

  const dividerStyle = {
    width: "40px",
    height: "2px",
    backgroundColor: "#d63031", // red color like in your image
  };

  return (
    <div style={containerStyle}>
      <div style={dividerStyle}></div>
      <h2 style={titleStyle}>{title}</h2>
    </div>
  );
};

export const FileUploaderNormal = ({ onChange, onRemove, disabled, field }) => {
  const [uploading, setUploading] = useState(false);
  const beforeUpload = (file) => {
    const fileExtension = file.name.split(".").pop().toLowerCase();

    const isImage =
      allowedImageExtensions.includes(fileExtension) ||
      allowedImageMimeTypes.includes(file.type);

    const isDocOrPdf =
      allowedDocExtensions.includes(fileExtension) ||
      allowedDocMimeTypes.includes(file.type);

    if (field === "signature" && !isImage) {
      message.error("Only image files are allowed");
      return Upload.LIST_IGNORE;
    }

    if (!isImage && !isDocOrPdf) {
      message.error("Only image, Word document, and PDF files are allowed");
      return Upload.LIST_IGNORE;
    }

    const isLt5MB = file.size / 1024 / 1024 < 100;
    if (!isLt5MB) {
      message.error("Image must be smaller than 100MB!");
      return Upload.LIST_IGNORE;
    }

    return true; // allow upload
  };

  const customRequest = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      setUploading(true);
      await onChange(file, (percent) => {
        onProgress({ percent });
      });

      onSuccess("Upload complete");
    } catch (err) {
      console.error(err);
      onError(err);
    } finally {
      setUploading(false);
    }
  };
  return (
    <Upload
      beforeUpload={beforeUpload}
      customRequest={customRequest}
      multiple={false}
      showUploadList={field === "signature" ? true : false}
      onRemove={onRemove}
      disabled={disabled || uploading}
    >
      <Button
        icon={uploading ? <LoadingOutlined /> : <UploadOutlined />}
        disabled={disabled || uploading}
      >
        {uploading
          ? "Uploading..."
          : `Click to Upload ${field === "signature" ? "Signature" : ""}`}
      </Button>
    </Upload>
  );
};

export const formatantdayjsDate = (dateString) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const convertToYMD = (value) => {
  const date = new Date(value);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const ErrorMessage = ({ error }) => {
  if (!error) return null;

  return (
    <div
      style={{
        color: "#ff4d4f",
        fontSize: "12px",
        marginTop: "4px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      <span>⚠</span>
      <span>{error}</span>
    </div>
  );
};

export const DownloadTemplate = (file, name) => {
  const link = document.createElement("a");
  link.href = file;
  link.download = name;
  link.click();
};
export const DownloadTemplateNewTab = (file, name) => {
  const link = document.createElement("a");
  link.href = file;
  link.download = name;
  link.target = "_blank"; // opens in new tab
  link.rel = "noopener noreferrer"; // security best practice
  link.click();
};